import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M16.409 3.533a2.25 2.25 0 0 1 3.181 0l1.591 1.59a2.25 2.25 0 0 1 0 3.182L10.944 18.543c-.308.308-.7.52-1.127.61l-4.269.9a.75.75 0 0 1-.9-.795l.013-.092.9-4.269c.09-.427.302-.819.61-1.127zM7.232 14.83a.75.75 0 0 0-.203.375l-.663 3.142 3.142-.663a.75.75 0 0 0 .375-.203l7.78-7.781-2.65-2.652zM18.53 4.593a.75.75 0 0 0-1.06 0L16.072 5.99l2.651 2.651 1.397-1.395a.75.75 0 0 0 0-1.06z" }, null, -1)
  ]))]))
}
export default { render: render }